import { useQuery } from '@tanstack/react-query';

import {
  getInvoicesAsPartyById,
  type GetInvoicesAsPartyByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function useInvoice(
  partyId: string,
  id: string,
  options?: QueryOptions<GetInvoicesAsPartyByIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.byId(partyId, id),
    queryFn: () =>
      getInvoicesAsPartyById(
        {
          path: { party_id: partyId, invoice_id: id },
        },
        wgApi,
      ),
    ...options,
  });
}
